module.exports = __webpack_public_path__ + "img/NUSISANCE_CALLS_MONITORING_UPDATE.png";